import { render, staticRenderFns } from "./component.vue?vue&type=template&id=066bf23d&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066bf23d')) {
      api.createRecord('066bf23d', component.options)
    } else {
      api.reload('066bf23d', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=066bf23d&", function () {
      api.rerender('066bf23d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-icon-svg/component.vue"
export default component.exports